<permission-checker [roles]="roles" (contentInit)="initContent()">
  <mat-form-field class="full-width">
    <mat-label [class.text-disabled-color]="disabled"
      i18n="Competition List|Select a competition prompt@@competition-list-select-one-prompt">Select a competition
    </mat-label>
    <mat-select [disabled]="disabled"
                (selectionChange)="competitionSelected($event)"
                [compareWith]="compareWith"
                [value]="selectedValue">
      <mat-option *ngFor="let competition of competitions" [value]="competition">{{competition.name}}</mat-option>
    </mat-select>
    <mat-spinner *ngIf="!competitions" diameter="15" color="primary" matSuffix></mat-spinner>
  </mat-form-field>
</permission-checker>
